import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Edit2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export default function AdminProducts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/admin/products").then((r) => setItems(r.data.products)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Delete this product and all its keys?")) return;
    await api.delete(`/admin/products/${id}`);
    toast.success("Product deleted");
    load();
  };

  return (
    <div data-testid="admin-products-page">
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className="font-mono text-xs uppercase tracking-widest text-[#00FF66]">// products</div>
          <h1 className="font-heading font-bold text-3xl mt-1">Manage products</h1>
        </div>
        <Link data-testid="admin-new-product" to="/admin/products/new" className="btn-primary"><Plus className="w-4 h-4" />new product</Link>
      </div>

      {loading ? (
        <div className="text-[#A1A1AA] font-mono">loading...</div>
      ) : (
        <div className="surface overflow-x-auto">
          <table className="w-full text-sm min-w-[700px]">
            <thead>
              <tr className="border-b border-[#1E293B] font-mono text-[11px] uppercase tracking-widest text-[#71717A]">
                <th className="text-left p-3">Product</th>
                <th className="text-left p-3">Category</th>
                <th className="text-right p-3">Price</th>
                <th className="text-right p-3">Keys</th>
                <th className="text-left p-3">Status</th>
                <th className="text-right p-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && <tr><td colSpan="6" className="p-6 text-center text-[#A1A1AA] font-mono">no products</td></tr>}
              {items.map((p) => (
                <tr key={p.id} className="border-b border-[#1E293B] last:border-0 hover:bg-white/[0.02]" data-testid={`admin-product-row-${p.slug}`}>
                  <td className="p-3">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded bg-[#0a0a0f] overflow-hidden shrink-0">
                        {p.images?.[0] ? <img src={p.images[0]} className="w-full h-full object-cover" alt="" /> : <div className="bg-grid w-full h-full" />}
                      </div>
                      <div>
                        <div className="font-medium">{p.name}</div>
                        <div className="font-mono text-[11px] text-[#71717A]">/{p.slug}</div>
                      </div>
                    </div>
                  </td>
                  <td className="p-3 font-mono text-xs">{p.category}</td>
                  <td className="p-3 text-right font-mono">${(p.price - (p.discount || 0)).toFixed(2)}</td>
                  <td className="p-3 text-right font-mono"><span className="text-[#00FF66]">{p.keys_available}</span> / {p.keys_total}</td>
                  <td className="p-3"><span className={`chip-mono ${!p.active ? "!bg-white/5 !text-[#A1A1AA] !border-white/10" : ""}`}>{p.active ? "active" : "inactive"}</span></td>
                  <td className="p-3 text-right">
                    <div className="inline-flex gap-2">
                      <Link to={`/admin/products/${p.id}`} className="btn-ghost !py-1.5 !px-3" data-testid={`edit-product-${p.slug}`}><Edit2 className="w-3.5 h-3.5" /></Link>
                      <button onClick={() => del(p.id)} className="btn-ghost !py-1.5 !px-3 hover:!border-[#FF3B30] hover:!text-[#FF3B30]" data-testid={`delete-product-${p.slug}`}><Trash2 className="w-3.5 h-3.5" /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
